<template>
<div class="form-group">
  <label class="control-label" :class="{ 'col-sm-4': horizontal }">{{ label }}</label>
  <div :class="{ 'col-sm-8': horizontal }">
    <div :class="{ 'input-group': hasAddon }">
      <slot></slot>
      <span class="input-group-btn" v-if="hasAddon">
        <slot name="addon"></slot>
      </span>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    label: {type: String, required: true},
    stacked: {type: Boolean, required: false, default: false}
  },
  computed: {
    hasAddon () {
      return !!this.$slots.addon
    },
    horizontal () {
      return !this.stacked
    }
  }
}
</script>



// WEBPACK FOOTER //
// FormGroup.vue?58fa744e